// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconFileAnalytics } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - REPORTS ||============================== //

const icons = {
    IconFileAnalytics
};
const reports: NavItemType = {
    id: 'reports-section',
    icon: icons.IconFileAnalytics,
    type: 'group',
    children: [{
        id: 'superAdminReport',
        title: <FormattedMessage id="Reports" />,
        type: 'item',
        icon: icons.IconFileAnalytics,
        url: '/report/super-admin',
        target: false
    }]
};

export default reports;
